import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import FormHelperText from '@material-ui/core/FormHelperText';

const useStyles = makeStyles((theme: any) => ({
  error: { textAlign: 'center', marginTop: theme.spacing(1) },
}));

interface Props {
  error: string;
}

export default function PageError({ error }: Props) {
  const classes = useStyles();

  return (
    <FormHelperText className={classes.error} error>
      {error}
    </FormHelperText>
  );
}
